import React, { useState } from 'react';
import { FormattedMessage } from "react-intl";
import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import { IconButton, Box, Button, Divider } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import '../css/global.css';

export const ConfirmationModal = ({ message, onLogout, onCancel, onClose }) => {

    const [openModal, setOpenModal] = useState(true);

    const handleCloseModal = () => {
        setOpenModal(false);
        onClose();
    };

    return (
        <>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={openModal} // Always set open to true in the ConfirmationModal component
                onClose={handleCloseModal}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                }}
            >
                <Fade in={openModal}>
                    <Box className="logout-confirmation">
                        <Box display="flex" alignItems="center" justifyContent="center">
                            <Box flexGrow={1} textAlign="center" paddingLeft="40px" paddingBottom="15px" paddingTop="15px">
                                <FormattedMessage id={message} />
                            </Box>
                            <IconButton>
                                <CloseIcon onClick={onClose}/>
                            </IconButton>
                        </Box>

                        <Divider />

                        <Box className="logout-action">
                            <Button onClick={onLogout} variant="contained" className="confirm-button">
                                <FormattedMessage id='logout.yes' />
                            </Button>
                            <Button onClick={onCancel} variant="contained" className="cancel-button">
                                <FormattedMessage id='logout.cancel' />
                            </Button>
                        </Box>

                    </Box>
                </Fade>
            </Modal>
        </>
    );
}